export const defineChipColor = (chip, colorByChip) => {
  let findColor;
  if (!chip) {
    return '';
  }
  if (colorByChip) {
    findColor = colorByChip?.find(
      (item, index) => item.chip <= chip && colorByChip[index + 1]?.chip > chip
    )?.color;
  }
  return findColor || colorByChip[colorByChip.length - 1]?.color;
};
